import { DataGrid } from "devextreme-react";
import ButtonReact from "devextreme-react/Button";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getPropsDataGrid } from "../../../../utils/default-props";
import { Button, Column, DataGridTypes, Item, Lookup, Selection, Toolbar } from "devextreme-react/cjs/data-grid";
import { useDataSource } from "../../../../contexts/dataSource";
import LoaderPage from "../../../../layouts/loader-page/loader-page";
import { getDataGridCustomToolbarCaption } from "../../../../components/default-components/data-grid-custom-toolbar";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../api/useAxios";
import notify from "devextreme/ui/notify";
import { DocumentCellRender } from "../documents/employee-document-list";

export function EmployeeDocumentAprovalList() {

    const refDataGrid = useRef()
    const { dataSourceHR } = useDataSource()
    const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false)
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate, "json")
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [confirmAllDisabled, setConfirmAllDisabled] = useState(true)

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeDocument/Approval`,
        //updateUrl: "/api/EmployeeDocument/Confirm/{id}",
    }), [dataSourceHR])

    const dbDocumentInfo = useMemo(() => dataSourceHR({
        loadUrl: "/api/EmployeeDocumentInfo"
    }), [dataSourceHR])

    const onSelectionChanged = useCallback((data: DataGridTypes.SelectionChangedEvent) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }, []);

    const handleConfirm = useCallback((e) => {
        // setConfirmButtonDisabled(!confirmButtonDisabled);
        // return;
        (async function () {

            setConfirmButtonDisabled(true)

            if (e.row?.data?.id) {
                await axiosPrivate.put(`/api/EmployeeDocument/Confirm/${e.row?.data?.id}`)
                    .then(response => {

                        refDataGrid.current.instance.refresh(true)
                        setConfirmButtonDisabled(false)
                        notify("İşlem başarılı", "success")

                    })
                    .catch(err => {
                        notify("İşlem başarısiz", "error")
                        setConfirmButtonDisabled(false)
                    })
            }

        })()

    }, [setConfirmButtonDisabled, axiosPrivate])

    const handleConfirmAll = useCallback((e) => {

        (async function () {

            setConfirmButtonDisabled(true)

            const data = {}
            data.values = JSON.stringify(selectedItemKeys)

            const axiosOptions = {
                method: "put",
                url: '/api/EmployeeDocument/ConfirmAll',
                data: JSON.stringify(selectedItemKeys)
            }

            if (selectedItemKeys) {
                await axiosPrivate(axiosOptions)
                    .then(response => {
                        refDataGrid.current.instance.refresh(true)
                        setConfirmButtonDisabled(false)
                        notify("İşlem başarılı", "success")

                    })
                    .catch(err => {
                        setConfirmButtonDisabled(false)
                        notify("İşlem başarısiz", "error")
                    })
            }
        })()

    }, [setConfirmButtonDisabled, axiosPrivate, selectedItemKeys])

    useEffect(() => {
        //console.log("selectedItemKeys", selectedItemKeys)
        setConfirmAllDisabled(selectedItemKeys.length === 0);
    }, [selectedItemKeys, setConfirmAllDisabled])

    return (
        <LoaderPage loading={false}>

            <DataGrid
                {...getPropsDataGrid}
                dataSource={dataSource}
                ref={refDataGrid}
                selectedRowKeys={selectedItemKeys}
                onSelectionChanged={onSelectionChanged}
            >
                <Toolbar>
                    {getDataGridCustomToolbarCaption('Onaylanacak Evrak Listesi')}
                    <Item location='after'>
                        <ButtonReact icon='importselected' disabled={confirmAllDisabled} onClick={handleConfirmAll} />
                    </Item>
                </Toolbar>
                <Selection mode="multiple" />
                <Column dataField="id" caption="ID" visible={false} />
                <Column dataField="employeeName" caption="Personel Adı" />
                <Column dataField="employeeSurname" caption="Personel Adı" />
                <Column
                    caption="Döküman Türü"
                    dataField="employeeDocumentInfoId"
                >
                    <Lookup dataSource={dbDocumentInfo} valueExpr="id" displayExpr="name" />

                </Column>

                <Column dataField="uploadDate" caption="Yükleme Tarihi" dataType="datetime" />
                <Column dataField="fileName" caption="Dosya Adı" />
                {/* <Column dataField="approvalStatus" caption="Onay Durumu" width={100} /> */}
                <Column caption="Onayla" type="buttons" width={110}>
                    {/* <Button hint="Göster" icon="find" onClick={handleShowDocument} /> */}
                    {!confirmButtonDisabled &&
                        <Button hint="Onayla" icon="check" onClick={handleConfirm} />
                    }
                    {/* Bu şekilde disablet güncellemedi */}
                    {/* <Button hint="Onayla" icon="check" visible={!confirmButtonDisabled} disabled={confirmButtonDisabled} onClick={handleConfirm} /> */}
                </Column>
                <Column caption="Belge" cellRender={DocumentCellRender} />
            </DataGrid>
        </LoaderPage>

    )
}
